import {css, cx} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";
import {Highlight, Text} from "@pg-design/text-module";
import {createReactTurnstileChallengeContainer, ITurnstileChallengeViewProps, TurnstileWidgetHost} from "@pg-mono/turnstile";

const TURNSTILE_MODAL_DESCRIPTION = "Potrzebujemy potwierdzenia, że jesteś człowiekiem. Dzięki temu chronimy formularze przed automatycznym spamem.";

const TurnstileChallengeModal = ({isOpen, onDismiss}: ITurnstileChallengeViewProps) => (
    <div className={cx(turnstileModalOverlayStyle, !isOpen && turnstileModalOverlayHiddenStyle)} data-rp-turnstile-modal={isOpen ? "true" : "false"}>
        <div
            aria-describedby="rp-turnstile-challenge-description"
            aria-labelledby="rp-turnstile-challenge-title"
            aria-modal="true"
            className={turnstileModalDialogStyle}
            role="dialog"
        >
            {onDismiss && (
                <button aria-label="Zamknij" className={turnstileModalCloseButtonStyle} onClick={onDismiss} type="button">
                    <CloseIcon size="1.6" wrapperSize="1.6" fill="var(--colors-secondary)" />
                </button>
            )}
            <Text as="h2" variant="headline_3" className={turnstileModalTitleStyle} id="rp-turnstile-challenge-title">
                Potwierdź, że <Highlight>jesteś człowiekiem</Highlight>
            </Text>
            <Text variant="body_copy_2" color="var(--colors-gray-800)" className={turnstileModalDescriptionStyle} id="rp-turnstile-challenge-description">
                {TURNSTILE_MODAL_DESCRIPTION}
            </Text>
            <TurnstileWidgetHost className={turnstileModalWidgetHostStyle} />
        </div>
    </div>
);

export const createTurnstileChallengeModal = createReactTurnstileChallengeContainer({
    ChallengeView: TurnstileChallengeModal,
    widgetTheme: "dark"
});

const turnstileModalOverlayStyle = css({
    alignItems: "center",
    backgroundColor: "rgb(from var(--colors-secondary) r g b / 0.35)",
    display: "flex",
    inset: 0,
    justifyContent: "center",
    p: 2,
    position: "fixed",
    // max 32-bit int = highest z-index browsers support; the challenge interrupts form submission and must stay above every app overlay
    zIndex: 2147483647
});

const turnstileModalOverlayHiddenStyle = css({
    pointerEvents: "none",
    visibility: "hidden"
});

const turnstileModalDialogStyle = css({
    backgroundColor: "var(--colors-white)",
    borderRadius: 2,
    maxHeight: "100%",
    maxWidth: "568px",
    overflow: "auto",
    p: 3,
    position: "relative",
    width: "100%",

    sm: {
        p: 4
    }
});

const turnstileModalCloseButtonStyle = css({
    alignItems: "center",
    backgroundColor: "var(--colors-white)",
    borderRadius: "50%",
    boxShadow: "var(--shadow-2)",
    cursor: "pointer",
    display: "flex",
    height: "4rem",
    justifyContent: "center",
    position: "absolute",
    right: 2,
    top: 2,
    width: "4rem"
});

const turnstileModalTitleStyle = css({
    mb: 2,
    pr: 5
});

const turnstileModalDescriptionStyle = css({
    mb: 3
});

const turnstileModalWidgetHostStyle = css({
    display: "flex",
    justifyContent: "center",
    minHeight: "65px",
    overflow: "hidden",
    width: "100%"
});
import {css, cx} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";
import {Highlight, Text} from "@pg-design/text-module";
import {createReactTurnstileChallengeContainer, ITurnstileChallengeViewProps, TurnstileWidgetHost} from "@pg-mono/turnstile";

const TURNSTILE_MODAL_DESCRIPTION = "Potrzebujemy potwierdzenia, że jesteś człowiekiem. Dzięki temu chronimy formularze przed automatycznym spamem.";

const TurnstileChallengeModal = ({isOpen, onDismiss}: ITurnstileChallengeViewProps) => (
    <div className={cx(turnstileModalOverlayStyle, !isOpen && turnstileModalOverlayHiddenStyle)} data-rp-turnstile-modal={isOpen ? "true" : "false"}>
        <div
            aria-describedby="rp-turnstile-challenge-description"
            aria-labelledby="rp-turnstile-challenge-title"
            aria-modal="true"
            className={turnstileModalDialogStyle}
            role="dialog"
        >
            {onDismiss && (
                <button aria-label="Zamknij" className={turnstileModalCloseButtonStyle} onClick={onDismiss} type="button">
                    <CloseIcon size="1.6" wrapperSize="1.6" fill="var(--colors-secondary)" />
                </button>
            )}
            <Text as="h2" variant="headline_3" className={turnstileModalTitleStyle} id="rp-turnstile-challenge-title">
                Potwierdź, że <Highlight>jesteś człowiekiem</Highlight>
            </Text>
            <Text variant="body_copy_2" color="var(--colors-gray-800)" className={turnstileModalDescriptionStyle} id="rp-turnstile-challenge-description">
                {TURNSTILE_MODAL_DESCRIPTION}
            </Text>
            <TurnstileWidgetHost className={turnstileModalWidgetHostStyle} />
        </div>
    </div>
);

export const createTurnstileChallengeModal = createReactTurnstileChallengeContainer({
    ChallengeView: TurnstileChallengeModal,
    widgetTheme: "dark"
});

const turnstileModalOverlayStyle = css({
    alignItems: "center",
    backgroundColor: "rgb(from var(--colors-secondary) r g b / 0.35)",
    display: "flex",
    inset: 0,
    justifyContent: "center",
    p: 2,
    position: "fixed",
    // max 32-bit int = highest z-index browsers support; the challenge interrupts form submission and must stay above every app overlay
    zIndex: 2147483647
});

const turnstileModalOverlayHiddenStyle = css({
    pointerEvents: "none",
    visibility: "hidden"
});

const turnstileModalDialogStyle = css({
    backgroundColor: "var(--colors-white)",
    borderRadius: 2,
    maxHeight: "100%",
    maxWidth: "568px",
    overflow: "auto",
    p: 3,
    position: "relative",
    width: "100%",

    sm: {
        p: 4
    }
});

const turnstileModalCloseButtonStyle = css({
    alignItems: "center",
    backgroundColor: "var(--colors-white)",
    borderRadius: "50%",
    boxShadow: "var(--shadow-2)",
    cursor: "pointer",
    display: "flex",
    height: "4rem",
    justifyContent: "center",
    position: "absolute",
    right: 2,
    top: 2,
    width: "4rem"
});

const turnstileModalTitleStyle = css({
    mb: 2,
    pr: 5
});

const turnstileModalDescriptionStyle = css({
    mb: 3
});

const turnstileModalWidgetHostStyle = css({
    display: "flex",
    justifyContent: "center",
    minHeight: "65px",
    overflow: "hidden",
    width: "100%"
});
